// extracted by mini-css-extract-plugin
export default {"button":"Button_button__pne1o","basic":"Button_basic__X9foJ","fullWidth":"Button_fullWidth__px+u9","disabled":"Button_disabled__W27qO"};